/**
 * FILTER-SELECT
 * Filtres choisis (puces) et une puce crayon pour les modifier dans la modale de choix des filtres
 */
import { useState } from "react"
import { createPortal } from "react-dom"
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons"
import Chip from "@/components/chip"
import SelectFilterNamesModal from "@/modals/select-filter-names.modal"

interface Props {
  names: string[]
  title: string
  help?: string
  example?: string
  isOrdered?: boolean //Numbered chips, reordered by drag and drop in the modal
  isOpenAtStart?: boolean //The modal opens with the component (ex: a checkbox just checked)
  onSave: (names: string[]) => Promise<boolean>
  onClose?: () => void
}

export default function FilterSelect({ names, title, help, example, isOrdered, isOpenAtStart, onSave, onClose }: Props) {
  const [isOpen, setIsOpen] = useState(Boolean(isOpenAtStart))

  return (
    <div className="chips-list">
      {names.map((name, index) => (
        <Chip key={name}>{isOrdered ? `${index + 1}. ${name}` : name}</Chip>
      ))}
      <Chip icon={faPencilAlt} onClick={() => setIsOpen(true)} />

      {/** Sur le body : la modale peut s'ouvrir depuis une autre modale */}
      {isOpen &&
        createPortal(
          <SelectFilterNamesModal
            title={title}
            help={help}
            example={example}
            isOrdered={isOrdered}
            selectedNames={names}
            onClose={() => {
              setIsOpen(false)
              onClose?.()
            }}
            onSave={onSave}
          />,
          document.body
        )}
    </div>
  )
}
